import { ReactComponent as FilterIcon } from './filter.svg';

export default FilterIcon;
